import { css } from '@genesislcap/web-core';

export const SimulatorStyles = css`
  :host {
    /* Add custom styles here if needed */
    --control-bar-height: 45px;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }

  .simulator-header {
    display: flex;
    padding: 20px;
    height: var(--control-bar-height);
    background: var(--neutral-layer-2);
    align-items: center;
    flex-shrink: 0;
  }

  .simulator-header h1 {
    margin: 0;
    color: var(--neutral-foreground-rest);
    font-size: 24px;
    font-weight: 600;
  }

  .simulator-main-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 20px;
    gap: 20px;
    overflow: auto;
    flex: 1;
    min-height: 0;
    align-items: flex-start;
  }

  .bulk-quote-section,
  .quote-status-section,
  .execution-report-section {
    background: var(--neutral-layer-1);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    min-width: 400px;
    flex-shrink: 0;
  }

  .bulk-quote-section h2,
  .quote-status-section h2,
  .execution-report-section h2 {
    margin: 0 0 20px 0;
    color: var(--neutral-foreground-rest);
    font-size: 18px;
    font-weight: 500;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  .input-group label {
    font-size: 14px;
    font-weight: 500;
    color: var(--neutral-foreground-rest);
  }

  .button-group {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
  }

  .button-group > rapid-button {
    min-width: 200px;
  }
`; 